// extracted by mini-css-extract-plugin
export default {"interiorOption":"zepKH9h2EZ","selected":"q90KDzyBIV"};